export class AsyncQueue {
  constructor() {
    this.queue = [];
    this.running = false;
  }

  enqueue(asyncFn) {
    this.queue.push(asyncFn);
    this.runNext();
  }

  async runNext() {
    if (this.running || this.queue.length === 0) return;

    this.running = true;
    const fn = this.queue.shift();

    try {
      await fn();
    } catch (e) {
      console.error('Error in async function:', e);
    }

    this.running = false;
    this.runNext();
  }
}